<template>
  <div class="register">
    <div class="r-portrait">
      <img :src="img" />
    </div>

    <div class="r-list" v-if="type === 1">
      <div class="r-input">
        <label>手机号</label>
        <input type="number" v-model="user.phone" placeholder="请填手机号" />
        <div class="getcode">
          <countDownBtn
            :title="'发送验证码'"
            @click.native="getcode"
            ref="countDown"
          >
          </countDownBtn>
        </div>
      </div>
      <div class="r-input">
        <label>验证码</label>
        <input
          style="width: 4.7rem"
          type="number"
          v-model="user.code"
          placeholder="请填写验证码"
        />
      </div>
    </div>

    <div class="r-list" v-if="type === 2">
      <div class="r-input">
        <label>用户名</label>
        <input type="text" v-model="user.username" placeholder="请填用户名" />
      </div>
      <div class="r-input">
        <label>密码</label>
        <input
          type="password"
          v-model="user.password"
          placeholder="请填写密码"
        />
      </div>
    </div>

    <div class="r-forget">
      <router-link to="login">已有账户 , 前往登录</router-link>
      <button @click="changeType">{{ type | type }}</button>
    </div>

    <div class="r-btn">
      <button @click="register">注册</button>
    </div>
  </div>
</template>
<script>
import { register, getcode, registerByPhone } from '@/api/user'
import { checkPhone } from "@/utils/regCheck"
import countDownBtn from '@/components/countDomnBtn'

import debounce from '@/utils/debounce'


export default {
  name: 'Register',
  components: {
    countDownBtn
  },
  data () {
    return {
      img: require('@/assets/logo.png'),
      user: {
        username: '',
        phone: '',
        password: '',
        code: '',
      },
      type: 1,
    }
  },
  methods: {
    async register () {
      const { user, type } = this
      let result;
      if (type === 1) {
        result = await registerByPhone({
          phone: user.phone,
          code: user.code
        })
      } else if (type === 2) {
        result = await register({
          username: user.username,
          password: user.password
        })
      }
      this.$toast(result.data.data.message)
      if (result.data.data.status) {
        this.$router.replace('/login')
      }
    },
    // responseHandle (result) {
    //   if (result.status) {
    //     this.$toast(result.data.message)
    //     this.$router.replace('/login')
    //   } else {
    //     this.$toast(result.data.message)
    //   }
    // },
    changeType () {
      this.type === 1 ? this.type = 2 : this.type = 1;
    },

    getcode: debounce(async function () {
      const { user: { phone }, $toast } = this

      if (checkPhone(phone)) return

      const result = await getcode({
        type: 'REGISTER_CODE',
        phone: phone
      })
      $toast(result.data.data.message)

      if (result.data.data.status) {
        this.$refs.countDown.start()
      } else {
        this.$refs.countDown.pause()
      }
    }, 200),
  },
  filters: {
    type (value) {
      if (value === 1) {
        return "密码注册"
      } else if (value === 2) {
        return "电话注册"
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.register {
  font-size: 0.12rem;
}
.r-portrait {
  margin: 1rem 3rem;
  width: 2rem;
  height: 2rem;
  display: flex;
  justify-content: center;
  align-items: center;
}
.r-list {
  width: 6.35rem;
  margin: auto;
  .r-input {
    display: flex;
    // justify-content: space-between;
    margin: 0.1rem 0;
    padding: 0.2rem 0;
    border-bottom: 1px solid #bbbbbb;
    align-items: center;
    label {
      font-size: 0.32rem;
      width: 1.3rem;
      color: #333333;
    }
    input {
      width: 2.8rem;
      font-size: 0.28rem;
      padding: 0.05rem;
      border: none;
      background: #f6f6f6;
    }
  }
}

.r-btn {
  text-align: center;
  margin-top: 1rem;
  button {
    width: 4.68rem;
    height: 0.99rem;
    border-radius: 30px;
    border: none;
    color: white;
    background: $globalcolor;
    font-size: 0.32rem;
  }
}

.r-forget {
  padding: 0 0.55rem;
  @include flexBox(space-between);

  a {
    color: #999999;
    font-size: 0.28rem;
  }
  button {
    @extend a;
    border: none;
    background: #f6f6f6;
  }
}

.getcode {
  button {
    width: 2rem;
    border: none;
    font-size: 0.32rem;
    background: #f6f6f6;
    color: #999999;
  }
}
</style>